// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__TinWV","loader":"Preloader_loader__pOg4i","spin":"Preloader_spin__Klcdy"};